import React, { Component } from 'react';
import i from '../imports';

const StyleText = {
    paddingTop: "8px",
    marginTop: "2px",
    marginBottom: "2px",
}

const StyleTitle = {
    fontSize: 24,
    paddingTop: "2px",
    paddingBottom: "8px",
    marginTop: "2px",
    marginBottom: "2px",
}


const StyleLink = {
    fontSize: 24,
    color: "#FF5563",
    cursor: "pointer"
}

const StyleImage = {
    borderRadius: "10px"
}

const googlemapsLink = 'https://maps.google.com/?q='

class CardsCarousel extends Component {

    constructor(props) {
        super(props);
        this.state ={
            totalElements: this.props.data.length,
        }

    }

    NextArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{ ...style,  color: "#FF5563",  right: '10px', zIndex: 1 }}
            onClick={onClick}
          ><i.Icon icon={i.faIcons.chevronRight} className="gallery-nav-icon"/></div>
        );
      }
      
      PrevArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{ ...style,  color: "#FF5563", left: '10px', zIndex: 1 }}
            onClick={onClick}
            ><i.Icon icon={i.faIcons.chevronLeft} className="gallery-nav-icon"/></div>
        );
      }

    renderCard(cardData){
        return (
            <i.Grid container spacing={24}>
                    <i.Grid container spacing={24} style={{ backgroundColor: this.props.backgroundColor, marginTop: "12px", padding: "12px 48px" }}>
                        <i.Grid item md={6}>
                            <div><img style={StyleImage} src={cardData.pic} width='100%' height='auto' /></div>
                        </i.Grid>
                        <i.Grid item md={6}>
                            <div style={StyleTitle}>{cardData.name}</div>
                            <div className="content-text" style={StyleText}>{cardData.text}</div>
                            <div style={StyleLink} onClick={() => {window.open(`${googlemapsLink}${cardData.address}`,'_blank')}}>{this.props.buttonText}</div>
                        </i.Grid>
                    </i.Grid>
            </i.Grid>
        );
    }

    render() {

        let cards = this.props.data;

        if(cards === undefined || cards.length <= 0)
            return null

            return (
                <i.SlickSlider style={{ backgroundColor: this.props.backgroundColor}} autoplay={false} wrapAround={true} arrows={true} dots={false} nextArrow={<this.NextArrow />} prevArrow={<this.PrevArrow />} >
                    {cards.map((m) => this.renderCard(m))}
                </i.SlickSlider>            
            );
    }
}

export default CardsCarousel;